import { render, staticRenderFns } from "./create-client.form.vue?vue&type=template&id=4ba18fb6&scoped=true&"
import script from "./create-client.form.vue?vue&type=script&lang=ts&"
export * from "./create-client.form.vue?vue&type=script&lang=ts&"
import style0 from "./create-client.form.vue?vue&type=style&index=0&id=4ba18fb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba18fb6",
  null
  
)

export default component.exports